module.exports = __webpack_public_path__ + "static/img/fixedCard.4ec5b53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/base/fixedCard.png
// module id = sz03
// module chunks = 0